const theme = {
  primary: '#35669a',
  secondary: '#1b3660',
  accent: '#f1bb4f',
  success: '#49b675',
  info: '#0a2b2b',
  warning: '#5f8a8b',
  error: '#da291c',
  danger: '#da291c',
  color: '#fff',
  grey: '#AEB4BE',
};

export default theme;
